/* eslint-disable */

import React from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Menu from '@99designs/react-components/components/Menu';
import HoverableElement from '@99designs/react-components/components/HoverableElement';
import MenuItemActionList from '@99designs/react-components/components/MenuItemActionList';
import ButtonMenuItemAction from '@99designs/react-components/components/ButtonMenuItemAction';

// FIXME: remove, these are not public api
import * as elementPosition from '@99designs/react-components/lib/elementPosition';
import keys from '@99designs/react-components/lib/keyConstants';
import { isLetterKeyCode } from '@99designs/react-components/lib/keyCodes';


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
// DEPRECATED COMPONENT, DO NOT USE!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //

/**
 * A wrapper component that adds dropdown behaviours to its wrapped children element.
 * It supports smart dropdown repositioning by default.
 *
 * Example:
 * var object1 = {label: 'foo', key: 'f1', ...}; // object1 contains props for creating MenuItemAction component
 * var items=[object1, ...]
 * <DropdownMenu itemData={items}><h1>world</h1></DropdownMenu>
 *
 * Note:
 * DropdownMenu make no assumption on the tab order of the anchor element it wraps. To allow full ARIA keyboard
 * behaviours, make sure the anchor element has tabbing enabled. (i.e. being form elements or having tabIndex)
 */

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
// DEPRECATED COMPONENT, DO NOT USE!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //

class DropdownMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isActive: false,
            currentFocusIndex: -1,
            isAnchorFocused: false,
        };

        this.anchorWrapper = null;

        this.onItemSelect = this.onItemSelect.bind(this);
        this.onItemKeyDown = this.onItemKeyDown.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.getMenuItem = this.getMenuItem.bind(this);
        this.deactivate = this.deactivate.bind(this);
        this.activate = this.activate.bind(this);
        this.toggle = this.toggle.bind(this);
        this.focusNextItem = this.focusNextItem.bind(this);
        this.focusPrevItem = this.focusPrevItem.bind(this);
        this.onAnchorClick = this.onAnchorClick.bind(this);
        this.onAnchorFocus = this.onAnchorFocus.bind(this);
        this.handleEscKey = this.handleEscKey.bind(this);
        this.handleLetterKeys = this.handleLetterKeys.bind(this);
        this.handleHoverElementShow = this.handleHoverElementShow.bind(this);
        this.handleHoverElementHide = this.handleHoverElementHide.bind(this);
    }

    componentDidUpdate() {
        if (this.state.isAnchorFocused) {
            this.focusOnAnchor();
            this.setState({ isAnchorFocused: false });
        }
    }

    focusOnAnchor() {
        $(this.anchorWrapper).children().focus();
    }

    getMenuItem(props, i) {
        return (
            <ButtonMenuItemAction
                {...props}
                key={props.key || props.label + i}
                isEnabled={true}
                isFocused={this.state.isActive && this.state.currentFocusIndex === i}
                onSelect={this.onItemSelect.bind(this, props)}
                onKeyDown={this.onItemKeyDown.bind(this, props)}
                onBlur={this.onBlur}
            />
        );
    }

    getHoverElement(menuItemsData) {
        return (
            <Menu variations={['constrained']}>
                <MenuItemActionList>
                    {menuItemsData.map(this.getMenuItem)}
                </MenuItemActionList>
            </Menu>
        );
    }

    activate() {
        if (!this.state.isActive) {
            this.setState({ isActive: true });
        }
    }

    deactivate(isAnchorFocused) {
        if (this.state.isActive) {
            this.setState({
                isActive: false,
                currentFocusIndex: -1,
                isAnchorFocused: (isAnchorFocused || false)
            });
        }
    }

    toggle() {
        if (this.state.isActive) {
            this.deactivate(true);
        } else {
            this.activate();
        }
    }

    focusNextItem(criteriaFunction, backward) {
        var options = this.props.itemData;
        var direction = backward ? -1 : 1;
        var targetIndex;
        var targetData;

        for (var i = 1; i <= options.length; i++) {
            targetIndex = (this.state.currentFocusIndex + options.length + direction * i) % options.length;
            targetData = options[targetIndex];

            if (!criteriaFunction || criteriaFunction(targetData)) {
                return this.setState({ currentFocusIndex: targetIndex });
            }
        }
    }

    focusPrevItem(criteriaFunction) {
        this.focusNextItem(criteriaFunction, true);
    }

    onAnchorClick() {
        this.toggle();
    }

    onAnchorFocus() {
        this.setState({ isAnchorFocused: true });
    }

    onAnchorKeyDown(event) {
        var hasHandledKey = false;

        hasHandledKey = hasHandledKey || this.handleEscKey(event);
        hasHandledKey = hasHandledKey || this.handleLetterKeys(event);

        if (event.key === keys.SPACE || event.key === keys.ENTER) {
            this.toggle();
            hasHandledKey = true;
        }

        if (event.key === keys.DOWN) {
            this.activate();
            this.focusNextItem();
            hasHandledKey = true;
        }

        if (hasHandledKey) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    onBlur() {
        // Use setTimeout to allow new activeElement be set before we handle the event.
        // this.isMounted check is required due to the asynchronous nature of setTimeout call.
        setTimeout(function () {
            var activeEl = document.activeElement;
            if (this.hoverElementNode && !$.contains(this.hoverElementNode, activeEl)) {
                this.deactivate();
            }
        }.bind(this), 0);
    }

    onItemKeyDown(itemData, event) {
        var hasHandledKey = false;

        hasHandledKey = hasHandledKey || this.handleEscKey(event);
        hasHandledKey = hasHandledKey || this.handleLetterKeys(event);

        if (event.key === keys.DOWN && this.state.isActive) {
            this.focusNextItem();
            hasHandledKey = true;
        }

        if (event.key === keys.UP && this.state.isActive) {
            this.focusPrevItem();
            hasHandledKey = true;
        }

        if (hasHandledKey) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    onItemSelect(selectedItemData) {
        if (this.props.onSelect) {
            this.props.onSelect(selectedItemData);
        }

        this.deactivate(true);
    }

    handleEscKey(keyEvent) {
        if (keyEvent.key === keys.ESCAPE && this.state.isActive) {
            this.deactivate(true);
            return true;
        }

        return false;
    }

    handleLetterKeys(keyEvent) {
        var letter = String.fromCharCode(keyEvent.keyCode);

        if (isLetterKeyCode(keyEvent.keyCode) && this.state.isActive) {
            this.focusNextItem(function (data) {
                return data.label && data.label.charAt(0).toLowerCase() === letter.toLowerCase();
            });
            return true;
        }

        return false;
    }

    handleHoverElementShow(hoverElementNode) {
        this.hoverElementNode = hoverElementNode;
    }

    handleHoverElementHide() {
        this.hoverElementNode = null;
    }

    render() {
        return (
            <HoverableElement
                hoverElement={this.getHoverElement(this.props.itemData)}
                hoverPosition={this.props.position}
                isActive={this.state.isActive}
                type='dropdown'
                hasTransition={false}
                onHoverElementShow={this.handleHoverElementShow}
                onHoverElementHide={this.handleHoverElementHide}
            >
                <span
                    onKeyDown={this.onAnchorKeyDown}
                    onBlur={this.onBlur}
                    onFocus={this.onAnchorFocus}
                    onClick={this.onAnchorClick}
                    className="hover-card-anchor"
                    aria-haspopup={true}
                    aria-expanded={this.state.isActive}
                    ref={(element) => { this.anchorWrapper = element; }}
                >
                    {this.props.children}
                </span>
            </HoverableElement>
        );
    }
}

DropdownMenu.defaultProps = {
    itemData: [],
    position: 'down-center',
}

DropdownMenu.propTypes = {
    onSelect: PropTypes.func,
    itemData: PropTypes.arrayOf(PropTypes.object),
    position: PropTypes.oneOf(elementPosition.getPossiblePositions()),
}

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/DropdownMenu.jsx